import { z } from "zod";

import apiClient from "../../../shared/api/client";

import type { SubscriptionsListResponse } from "../types";

const subscriptionSchema = z.object({
  id: z.string(),

  userId: z.number(),

  planId: z.string(),

  status: z.enum(["pending", "active", "expired", "cancelled"]),

  txHash: z.string().nullable(),

  paymentAmountUsdt: z.coerce.number().nullable(),

  walletAddress: z.string().nullable(),

  chainId: z.number().nullable(),

  paidAt: z.string().nullable(),

  startsAt: z.string(),

  expiresAt: z.string(),

  autoRenew: z.boolean(),

  user: z

    .object({
      id: z.number(),

      name: z.string().nullable(),

      lastName: z.string().nullable(),

      email: z.string().nullable(),

      username: z.string().nullable(),
    })

    .nullable(),

  plan: z

    .object({
      id: z.string(),

      key: z.string(),

      name: z.string(),

      type: z.string(),

      monthlyPrice: z.coerce.number(),
    })

    .nullable(),

  createdAt: z.string(),

  updatedAt: z.string(),

  deletedAt: z.string().nullable(),
});

const subscriptionsListResponseSchema = z.object({
  data: z.array(subscriptionSchema),
});

export const fetchSubscriptions =
  async (): Promise<SubscriptionsListResponse> => {
    const response = await apiClient.get("/subscriptions");

    return subscriptionsListResponseSchema.parse(response.data);
  };
